import React, { Component } from 'react';

const TableHead = () => (
    <thead className="thead-light">
        <tr>
            <th scope="col">Nome</th>
            <th scope="col">Endereço</th>
            <th scope="col">Cidade</th>
            <th scope="col">Telefone</th>
            <th scope="col">Data de Criação</th>
            <th scope="col">Status</th>
            {/* <th scope="col"></th> */}
        </tr>
    </thead>
);

export default TableHead;


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/TableHead.js